export enum UserRoles {
  ADMIN = 'Paper Admins',
  MANAGER = 'Paper Managers',
  BUSINESSUSER = 'Paper Business User',
  IMPLEMENTERS = 'Paper Implementers',
}
